var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var NullFilter_1, SingleStringFilter_1, SingleNumberFilter_1, SingleDateFilter_1, SingleBooleanFilter_1, TwoNumberFilter_1, TwoDateFilter_1, ArrayStringFilter_1, ArrayNumberFilter_1, ArrayDateFilter_1, ArrayBooleanFilter_1, ArrayArrayFilter_1, SomeFilter_1;
import { DateTime } from "luxon";
import { Directive, Field, InputType, registerEnumType } from "type-graphql";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
export const NoTargetOperators = {
    IS_NULL: "IS_NULL",
    IS_NOT_NULL: "IS_NOT_NULL",
};
registerEnumType(NoTargetOperators, { name: "NoTargetOperators" });
export const SingleTargetOperators = {
    EQUALS: "EQUALS",
    NOT_EQUALS: "NOT_EQUALS",
    GREATER_THAN: "GREATER_THAN",
    GREATER_THAN_OR_EQUAL_TO: "GREATER_THAN_OR_EQUAL_TO",
    LESS_THAN: "LESS_THAN",
    LESS_THAN_OR_EQUAL_TO: "LESS_THAN_OR_EQUAL_TO",
    CONTAINS: "CONTAINS",
    NOT_CONTAINS: "NOT_CONTAINS",
    INSENSITIVE_CONTAINS: "INSENSITIVE_CONTAINS",
    INSENSITIVE_NOT_CONTAINS: "INSENSITIVE_NOT_CONTAINS",
    STARTS_WITH: "STARTS_WITH",
    NOT_STARTS_WITH: "NOT_STARTS_WITH",
    INSENSITIVE_STARTS_WITH: "INSENSITIVE_STARTS_WITH",
    INSENSITIVE_NOT_STARTS_WITH: "INSENSITIVE_NOT_STARTS_WITH",
    ENDS_WITH: "ENDS_WITH",
    NOT_ENDS_WITH: "NOT_ENDS_WITH",
    INSENSITIVE_ENDS_WITH: "INSENSITIVE_ENDS_WITH",
    INSENSITIVE_NOT_ENDS_WITH: "INSENSITIVE_NOT_ENDS_WITH",
};
registerEnumType(SingleTargetOperators, { name: "SingleTargetOperators" });
export const TwoTargetOperators = {
    BETWEEN: "BETWEEN",
    NOT_BETWEEN: "NOT_BETWEEN",
};
registerEnumType(TwoTargetOperators, { name: "TwoTargetOperators" });
export const ArrayOperators = {
    IN: "IN",
    NOT_IN: "NOT_IN",
};
registerEnumType(ArrayOperators, { name: "ArrayOperators" });
export const ArrayArrayOperators = {
    EQUALS: "EQUALS",
    HAS: "HAS",
    HAS_EVERY: "HAS_EVERY",
    HAS_SOME: "HAS_SOME",
    IS_EMPTY: "IS_EMPTY",
};
registerEnumType(ArrayArrayOperators, { name: "ArrayArrayOperators" });
let NullFilter = NullFilter_1 = class NullFilter {
    comparison;
    static from(comparison) {
        const val = new NullFilter_1();
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => NoTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], NullFilter.prototype, "comparison", void 0);
NullFilter = NullFilter_1 = __decorate([
    InputType()
], NullFilter);
export { NullFilter };
let SingleStringFilter = SingleStringFilter_1 = class SingleStringFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new SingleStringFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], SingleStringFilter.prototype, "value", void 0);
__decorate([
    Field(() => SingleTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], SingleStringFilter.prototype, "comparison", void 0);
SingleStringFilter = SingleStringFilter_1 = __decorate([
    InputType()
], SingleStringFilter);
export { SingleStringFilter };
let SingleNumberFilter = SingleNumberFilter_1 = class SingleNumberFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new SingleNumberFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], SingleNumberFilter.prototype, "value", void 0);
__decorate([
    Field(() => SingleTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], SingleNumberFilter.prototype, "comparison", void 0);
SingleNumberFilter = SingleNumberFilter_1 = __decorate([
    InputType()
], SingleNumberFilter);
export { SingleNumberFilter };
let SingleDateFilter = SingleDateFilter_1 = class SingleDateFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new SingleDateFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], SingleDateFilter.prototype, "value", void 0);
__decorate([
    Field(() => SingleTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], SingleDateFilter.prototype, "comparison", void 0);
SingleDateFilter = SingleDateFilter_1 = __decorate([
    InputType()
], SingleDateFilter);
export { SingleDateFilter };
let SingleBooleanFilter = SingleBooleanFilter_1 = class SingleBooleanFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new SingleBooleanFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], SingleBooleanFilter.prototype, "value", void 0);
__decorate([
    Field(() => SingleTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], SingleBooleanFilter.prototype, "comparison", void 0);
SingleBooleanFilter = SingleBooleanFilter_1 = __decorate([
    InputType()
], SingleBooleanFilter);
export { SingleBooleanFilter };
let TwoNumberFilter = TwoNumberFilter_1 = class TwoNumberFilter {
    lower;
    upper;
    comparison;
    static from(lower, upper, comparison) {
        const val = new TwoNumberFilter_1();
        val.lower = lower;
        val.upper = upper;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], TwoNumberFilter.prototype, "lower", void 0);
__decorate([
    Field(() => Number, { nullable: false }),
    __metadata("design:type", Number)
], TwoNumberFilter.prototype, "upper", void 0);
__decorate([
    Field(() => TwoTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], TwoNumberFilter.prototype, "comparison", void 0);
TwoNumberFilter = TwoNumberFilter_1 = __decorate([
    InputType()
], TwoNumberFilter);
export { TwoNumberFilter };
let TwoDateFilter = TwoDateFilter_1 = class TwoDateFilter {
    lower;
    upper;
    comparison;
    static from(lower, upper, comparison) {
        const val = new TwoDateFilter_1();
        val.lower = lower;
        val.upper = upper;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], TwoDateFilter.prototype, "lower", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: false }),
    __metadata("design:type", DateTime)
], TwoDateFilter.prototype, "upper", void 0);
__decorate([
    Field(() => TwoTargetOperators, { nullable: false }),
    __metadata("design:type", String)
], TwoDateFilter.prototype, "comparison", void 0);
TwoDateFilter = TwoDateFilter_1 = __decorate([
    InputType()
], TwoDateFilter);
export { TwoDateFilter };
let ArrayStringFilter = ArrayStringFilter_1 = class ArrayStringFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new ArrayStringFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => [String], { nullable: false }),
    __metadata("design:type", Array)
], ArrayStringFilter.prototype, "value", void 0);
__decorate([
    Field(() => ArrayOperators, { nullable: false }),
    __metadata("design:type", String)
], ArrayStringFilter.prototype, "comparison", void 0);
ArrayStringFilter = ArrayStringFilter_1 = __decorate([
    InputType()
], ArrayStringFilter);
export { ArrayStringFilter };
let ArrayNumberFilter = ArrayNumberFilter_1 = class ArrayNumberFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new ArrayNumberFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => [Number], { nullable: false }),
    __metadata("design:type", Array)
], ArrayNumberFilter.prototype, "value", void 0);
__decorate([
    Field(() => ArrayOperators, { nullable: false }),
    __metadata("design:type", String)
], ArrayNumberFilter.prototype, "comparison", void 0);
ArrayNumberFilter = ArrayNumberFilter_1 = __decorate([
    InputType()
], ArrayNumberFilter);
export { ArrayNumberFilter };
let ArrayDateFilter = ArrayDateFilter_1 = class ArrayDateFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new ArrayDateFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => [DateTimeScalar], { nullable: false }),
    __metadata("design:type", Array)
], ArrayDateFilter.prototype, "value", void 0);
__decorate([
    Field(() => ArrayOperators, { nullable: false }),
    __metadata("design:type", String)
], ArrayDateFilter.prototype, "comparison", void 0);
ArrayDateFilter = ArrayDateFilter_1 = __decorate([
    InputType()
], ArrayDateFilter);
export { ArrayDateFilter };
let ArrayBooleanFilter = ArrayBooleanFilter_1 = class ArrayBooleanFilter {
    value;
    comparison;
    static from(value, comparison) {
        const val = new ArrayBooleanFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => [Boolean], { nullable: false }),
    __metadata("design:type", Array)
], ArrayBooleanFilter.prototype, "value", void 0);
__decorate([
    Field(() => ArrayOperators, { nullable: false }),
    __metadata("design:type", String)
], ArrayBooleanFilter.prototype, "comparison", void 0);
ArrayBooleanFilter = ArrayBooleanFilter_1 = __decorate([
    InputType()
], ArrayBooleanFilter);
export { ArrayBooleanFilter };
let ArrayArrayFilter = ArrayArrayFilter_1 = class ArrayArrayFilter {
    value = [];
    comparison;
    static from(value, comparison) {
        if (comparison === ArrayArrayOperators.IS_EMPTY && value.length > 0) {
            throw new TypeError("Value must be empty for IS_EMPTY comparison");
        }
        if (comparison !== ArrayArrayOperators.HAS && value.length !== 1) {
            throw new TypeError("Value must contain exactly one element for HAS comparison");
        }
        const val = new ArrayArrayFilter_1();
        val.value = value;
        val.comparison = comparison;
        return val;
    }
};
__decorate([
    Field(() => [String], { nullable: false }),
    __metadata("design:type", Array)
], ArrayArrayFilter.prototype, "value", void 0);
__decorate([
    Field(() => ArrayArrayOperators, { nullable: false }),
    __metadata("design:type", String)
], ArrayArrayFilter.prototype, "comparison", void 0);
ArrayArrayFilter = ArrayArrayFilter_1 = __decorate([
    InputType()
], ArrayArrayFilter);
export { ArrayArrayFilter };
let SomeFilter = SomeFilter_1 = class SomeFilter {
    nullFilter;
    singleStringFilter;
    singleNumberFilter;
    singleDateFilter;
    singleBooleanFilter;
    twoNumberFilter;
    twoDateFilter;
    arrayStringFilter;
    arrayNumberFilter;
    arrayDateFilter;
    arrayBooleanFilter;
    arrayArrayFilter;
    static getFilter(some) {
        const { nullFilter, singleStringFilter, singleNumberFilter, singleDateFilter, singleBooleanFilter, twoNumberFilter, twoDateFilter, arrayStringFilter, arrayNumberFilter, arrayDateFilter, arrayBooleanFilter, arrayArrayFilter, } = some;
        return (nullFilter ??
            singleStringFilter ??
            singleNumberFilter ??
            singleDateFilter ??
            singleBooleanFilter ??
            twoNumberFilter ??
            twoDateFilter ??
            arrayStringFilter ??
            arrayNumberFilter ??
            arrayDateFilter ??
            arrayBooleanFilter ??
            arrayArrayFilter);
    }
    static from(filter) {
        const val = new SomeFilter_1();
        if (filter instanceof NullFilter) {
            val.nullFilter = filter;
        }
        else if (filter instanceof SingleStringFilter) {
            val.singleStringFilter = filter;
        }
        else if (filter instanceof SingleNumberFilter) {
            val.singleNumberFilter = filter;
        }
        else if (filter instanceof SingleDateFilter) {
            val.singleDateFilter = filter;
        }
        else if (filter instanceof SingleBooleanFilter) {
            val.singleBooleanFilter = filter;
        }
        else if (filter instanceof TwoNumberFilter) {
            val.twoNumberFilter = filter;
        }
        else if (filter instanceof TwoDateFilter) {
            val.twoDateFilter = filter;
        }
        else if (filter instanceof ArrayStringFilter) {
            val.arrayStringFilter = filter;
        }
        else if (filter instanceof ArrayNumberFilter) {
            val.arrayNumberFilter = filter;
        }
        else if (filter instanceof ArrayDateFilter) {
            val.arrayDateFilter = filter;
        }
        else if (filter instanceof ArrayBooleanFilter) {
            val.arrayBooleanFilter = filter;
        }
        else if (filter instanceof ArrayArrayFilter) {
            val.arrayArrayFilter = filter;
        }
        else {
            throw new TypeError("Invalid filter type");
        }
        return val;
    }
};
__decorate([
    Field(() => NullFilter, { nullable: true }),
    __metadata("design:type", NullFilter)
], SomeFilter.prototype, "nullFilter", void 0);
__decorate([
    Field(() => SingleStringFilter, { nullable: true }),
    __metadata("design:type", SingleStringFilter)
], SomeFilter.prototype, "singleStringFilter", void 0);
__decorate([
    Field(() => SingleNumberFilter, { nullable: true }),
    __metadata("design:type", SingleNumberFilter)
], SomeFilter.prototype, "singleNumberFilter", void 0);
__decorate([
    Field(() => SingleDateFilter, { nullable: true }),
    __metadata("design:type", SingleDateFilter)
], SomeFilter.prototype, "singleDateFilter", void 0);
__decorate([
    Field(() => SingleBooleanFilter, { nullable: true }),
    __metadata("design:type", SingleBooleanFilter)
], SomeFilter.prototype, "singleBooleanFilter", void 0);
__decorate([
    Field(() => TwoNumberFilter, { nullable: true }),
    __metadata("design:type", TwoNumberFilter)
], SomeFilter.prototype, "twoNumberFilter", void 0);
__decorate([
    Field(() => TwoDateFilter, { nullable: true }),
    __metadata("design:type", TwoDateFilter)
], SomeFilter.prototype, "twoDateFilter", void 0);
__decorate([
    Field(() => ArrayStringFilter, { nullable: true }),
    __metadata("design:type", ArrayStringFilter)
], SomeFilter.prototype, "arrayStringFilter", void 0);
__decorate([
    Field(() => ArrayNumberFilter, { nullable: true }),
    __metadata("design:type", ArrayNumberFilter)
], SomeFilter.prototype, "arrayNumberFilter", void 0);
__decorate([
    Field(() => ArrayDateFilter, { nullable: true }),
    __metadata("design:type", ArrayDateFilter)
], SomeFilter.prototype, "arrayDateFilter", void 0);
__decorate([
    Field(() => ArrayBooleanFilter, { nullable: true }),
    __metadata("design:type", ArrayBooleanFilter)
], SomeFilter.prototype, "arrayBooleanFilter", void 0);
__decorate([
    Field(() => ArrayArrayFilter, { nullable: true }),
    __metadata("design:type", ArrayArrayFilter)
], SomeFilter.prototype, "arrayArrayFilter", void 0);
SomeFilter = SomeFilter_1 = __decorate([
    Directive("@oneof"),
    InputType()
], SomeFilter);
export { SomeFilter };
export const FilterGroupOperator = {
    AND: "AND",
    OR: "OR",
};
registerEnumType(FilterGroupOperator, { name: "FilterGroupOperator" });
let AbstractFilterItem = class AbstractFilterItem {
    field;
    filter;
};
__decorate([
    Field(() => SomeFilter, { nullable: false }),
    __metadata("design:type", SomeFilter)
], AbstractFilterItem.prototype, "filter", void 0);
AbstractFilterItem = __decorate([
    InputType()
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
], AbstractFilterItem);
export { AbstractFilterItem };
export function createFilterItem(fieldEnum, resolverName) {
    let FilterItem = class FilterItem extends AbstractFilterItem {
    };
    __decorate([
        Field(() => fieldEnum, { nullable: false }),
        __metadata("design:type", String)
    ], FilterItem.prototype, "field", void 0);
    FilterItem = __decorate([
        InputType(`${resolverName}FilterItem`)
    ], FilterItem);
    return FilterItem;
}
let AbstractFilterGroup = class AbstractFilterGroup {
};
__decorate([
    Field(() => FilterGroupOperator, { nullable: false }),
    __metadata("design:type", String)
], AbstractFilterGroup.prototype, "operator", void 0);
AbstractFilterGroup = __decorate([
    InputType()
], AbstractFilterGroup);
export { AbstractFilterGroup };
export function createFilterGroup(fieldEnum, resolverName) {
    const FilterItem = createFilterItem(fieldEnum, resolverName);
    let FilterGroup = class FilterGroup extends AbstractFilterGroup {
        filters = [];
        children = [];
    };
    __decorate([
        Field(() => [FilterItem], { nullable: false }),
        __metadata("design:type", Array)
    ], FilterGroup.prototype, "filters", void 0);
    __decorate([
        Field(() => [FilterGroup], { nullable: false }),
        __metadata("design:type", Array)
    ], FilterGroup.prototype, "children", void 0);
    FilterGroup = __decorate([
        InputType(`${resolverName}FilterGroup`)
    ], FilterGroup);
    return FilterGroup;
}
//# sourceMappingURL=Filter.js.map